/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  box-sizing: border-box;
  display: inline-block;
  contain: content;
  width: 100%;
  height: 100%;
}
:host > svg {
  height: 100%;
  width: 100%;
}
:host > svg .label {
  font-weight: normal;
  font-size: 0.7rem;
}
:host > davinci-legend {
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

circle {
  stroke: #EEEFF0;
  stroke: var(--davinci-color-background-3, #EEEFF0);
}

:host(:not([legend-labels])) {
  padding: 1rem;
}

:host([hidden]) {
  display: none;
}`;
export { style };
